import { render, staticRenderFns } from "./reports-tabs.vue?vue&type=template&id=1b095d69"
import script from "./reports-tabs.vue?vue&type=script&lang=ts"
export * from "./reports-tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports